import { useContext } from 'react';

import PlaceContext from './PlaceContext';
import PlaceContextData from './PlaceContextData';

export function useOptionalPlaceContext(): PlaceContextData | null {
  const placeContextData = useContext(PlaceContext);
  return placeContextData;
}

export default function usePlaceContext(): PlaceContextData {
  const placeContextData = useContext(PlaceContext);
  if (placeContextData === null) throw new Error('usePlaceContext cannot be used outside of PlaceContext.Provider');
  return placeContextData;
}
